@if (options()) {
  @if (options().label) {
    <label
      [id]="options().label?.id"
      [for]="!invalidMessage && options().id"
      [class]="'form-label ' + (options().label?.class || '')"
    >
      {{ translations.labels[options().label?.text || 'label'] || options().label?.text }}
      @if (options().required) {
        <span class="required">*</span>
      }
    </label>
  }
  @if (options().formGroup && options().formControlName && !options().formControl) {
    <span [formGroup]="options().formGroup!">
      <textarea
        #el
        [id]="options().id"
        [attr.name]="options().name"
        [class]="'form-control ncp-input ' + (options().inputClass || '')"
        [placeholder]="translations.placeholders[options().placeholder || 'default'] || options().placeholder"
        [formControlName]="options().formControlName!"
        (keydown)="onKeyDown($event, el.value, $any($event).target)"
        (keyup)="onKeyUp($event, el.value)"
        (input)="onInput($any($event).target)"
        (blur)="onBlur(el.value, $any($event).target)"
        [value]="options().value"
        [rows]="options().rows"
      ></textarea>
    </span>
  } @else if (!options().formGroup && !options().formControlName && options().formControl) {
    <textarea
      #el
      [id]="options().id"
      [attr.name]="options().name"
      [class]="'form-control ncp-input ' + (options().inputClass || '')"
      [placeholder]="translations.placeholders[options().placeholder || 'default']"
      [formControl]="options().formControl!"
      (keydown)="onKeyDown($event, el.value, $any($event).target)"
      (keyup)="onKeyUp($event, el.value)"
      (input)="onInput($any($event).target)"
      (blur)="onBlur(el.value, $any($event).target)"
      [value]="options().value"
      [rows]="options().rows"
    ></textarea>
  } @else if (!options().formGroup && !options().formControlName && !options().formControl) {
    <textarea
      #el
      [id]="options().id"
      [attr.name]="options().name"
      [class]="'form-control ncp-input ' + (options().inputClass || '')"
      [placeholder]="translations.placeholders[options().placeholder || 'default']"
      (keydown)="onKeyDown($event, el.value, $any($event).target)"
      (keyup)="onKeyUp($event, el.value)"
      (input)="onInput($any($event).target)"
      (blur)="onBlur(el.value, $any($event).target)"
      [value]="options().value"
      [rows]="options().rows"
    ></textarea>
  } @else if (options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and the
      combination FormGroup - FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormGroup at the same time
    </div>
  } @else if (!options().formGroup && options().formControlName && options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControl and
      FormControlName at the same time
    </div>
  } @else if (options().formGroup && !options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormGroup without
      setting FormControlName too
    </div>
  } @else if (!options().formGroup && options().formControlName && !options().formControl) {
    <div
      class="alert alert-danger"
      role="alert"
    >
      <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot set FormControlName
      without setting FormGroup too
    </div>
  }
  <div class="invalid-feedback">
    {{ invalidMessage }}
  </div>
} @else {
  <div
    class="alert alert-danger"
    role="alert"
  >
    <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot instantiate input without
    options() set
  </div>
}
